<template>
  <div>
    <div class="first-time-registration">
      <h1>Velkommen til portalen!</h1>
      <p>Vennligst fyll inn din informasjon for å fullføre registreringen.</p>
      <div class="error-message" v-if="savedFailed">
        <!-- TODO: Her kunne vi hatt en fin rød X-ikon, eller lignende.  -->
        <p>
          Vennligst se igjennom skjemaet og se til at alle nødvendige felter er
          fylt ut.
        </p>
      </div>
    </div>

    <div class="grid-container">
      <div>
        <label class="labelText">E-post</label>
        <input type="text" disabled v-model="email" />
      </div>

      <div>
        <label>Fornavn <span class="required">*</span></label>
        <input type="text" v-model="firstName" required />
      </div>

      <div>
        <label>Etternavn <span class="required">*</span></label>
        <input type="text" v-model="lastName" required />
      </div>

      <div>
        <label>Fødselsdato <span class="required">*</span></label>
        <input type="date" v-model="birthDate" required />
      </div>

      <div>
        <label>Telefonnummer <span class="required">*</span></label>
        <input type="number" v-model="telephone" required />
      </div>

      <div>
        <label>Bosted</label>
        <input type="text" v-model="city" />
      </div>

      <div>
        <input type="checkbox" v-model="userConsent" />
        <span>
          Jeg godtar
          <a target="_BLANK" href="/#/personvern">personvernsvilkårene</a>
        </span>
      </div>

      <div @click="createUserInfo">
        <LinkButton
          :disabled="isWorking"
          :text="isWorking ? 'Arbeider...' : 'Lagre og fortsett til profilen'"
        />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "FirstTimeRegistration",
  data() {
    return {
      firstName: null,
      lastName: null,
      birthDate: null,
      telephone: null,
      email: this.$auth.user.email,
      city: null,

      auth0Id: this.$auth.user.sub,
      userConsent: false,

      savedSuccessful: false,
      savedFailed: false,
      isWorking: false,
    };
  },
  methods: {
    async createUserInfo() {
      let birthDateDate = new Date(this.birthDate);
      if (this.userConsent == false) return (this.savedFailed = true);
      if (birthDateDate.getFullYear() < 1900) {
        return (this.savedFailed = true);
      }

      // Mindre enn 8 siffer
      // TODO: Endre telefonnummer til string, og sjekk at det er ingen bokstaver i.
      if (this.telephone < 10000000) {
        return (this.savedFailed = true);
      }

      this.isWorking = true;
      const token = await this.$auth.getTokenSilently();

      let postdata = {
        auth0id: this.$auth.user.sub,
        firstName: this.firstName,
        lastName: this.lastName,
        birthDate: this.birthDate,
        telephone: this.telephone,
        email: this.email,
        city: this.city,
        // canMove: true,
        // canWorkFullTime: true,
      };

      let axiosConfig = {
        headers: {
          Authorization: `Bearer ${token}`, // send the access token through the 'Authorization' header
        },
      };

      axios
        .post(
          `${this.$store.state.baseApiUrl}/candidate`,
          postdata,
          axiosConfig
        )
        .then(() => {
          this.savedSuccessful = true;
          this.savedFailed = false;
          this.$router.push("/profil");
        })
        .catch(() => {
          this.savedSuccessful = false;
          this.savedFailed = true;
          this.isWorking = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.required {
  color: red;
}

.first-time-registration {
  text-align: center;
}

.error-message {
  background-color: #dc3545;
  color: white;
  padding: 1em;
  margin: 1em 0;
  border-radius: var(--border-radius);
}

.grid-container {
  display: grid;
  justify-content: space-evenly;
  grid-template-columns: 450px; /*Make the grid smaller than the container*/
}

.grid-container > div {
  background-color: rgba(255, 255, 255, 0.8);
  font-size: 15px;
  margin: 10px;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] {
  -moz-appearance: textfield;
}

input[type="text"],
input[type="number"],
input[type="date"],
textarea,
.button {
  width: 100%;
  box-sizing: border-box;
}

input[type="checkbox"] {
  margin-right: 0.5em;
}

//Mobil CSS
@media only screen and (max-width: 856px) {
  .grid-container {
    grid-template-columns: auto; /*Make the grid smaller than the container*/
  }
}
</style>